import { UIHeading4, UIHeading5, UIText1 } from '@cian/ui-kit';
import { IconSocialDislikeOn16, IconSocialLikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { IFavoriteEntity, ELikeDislikeReaction } from '../../../types/favoriteEntity';

interface IClientCommentProps {
  clientReactions?: IFavoriteEntity['clientReactions'];
  isSearcherOrSub?: boolean;
}

export const ClientComment = ({ clientReactions, isSearcherOrSub }: IClientCommentProps) => {
  if (!clientReactions) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        {clientReactions.likeDislikeReaction === ELikeDislikeReaction.Like && (
          <div className={styles['reaction']} data-testid="like_block">
            <IconSocialLikeOn16 color="icon-positive-default" />
            <UIHeading5 color="text-positive-default">{isSearcherOrSub ? 'Нравится' : 'Нравится клиенту'}</UIHeading5>
          </div>
        )}
        {clientReactions.likeDislikeReaction === ELikeDislikeReaction.Dislike && (
          <div className={styles['reaction']} data-testid="dislike_block">
            <IconSocialDislikeOn16 color="icon-negative-default" />
            <UIHeading5 color="text-negative-default">
              {isSearcherOrSub ? 'Не нравится' : 'Не нравится клиенту'}
            </UIHeading5>
          </div>
        )}
        {clientReactions.comment && (
          <div className={styles['comment']} data-testid="comment_block">
            <UIHeading4>{isSearcherOrSub ? 'Комментарий' : 'Комментарий клиента'}</UIHeading4>
            <UIText1>{clientReactions.comment}</UIText1>
          </div>
        )}
      </div>
    </div>
  );
};
